export function getYearFirstDay(){
    // 获取当前年份  
    let currentYear = new Date().getFullYear();

// 创建表示当前年份第一天的Date对象  
    let firstDayOfYear = new Date(currentYear, 0, 1);

// 获取年份、月份（加1以转换为常规月份编号）和日期  
    let year = firstDayOfYear.getFullYear();
    let month = ("0" + (firstDayOfYear.getMonth() + 1)).slice(-2); // 月份从0开始，所以加1，并补零  
    let day = ("0" + firstDayOfYear.getDate()).slice(-2); // 补零  

// 拼接成yyyy-mm-dd格式  
    return year + "-" + month + "-" + day;

}